<div class="overlay" *ngIf="loading">
    <mat-progress-bar
        class="example-margin"
        [color]="color"
        [mode]="mode"
        [value]="value">
    </mat-progress-bar>
</div>